<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="20"
     [transparentOverlay]="true"
>
    <div class='scrollable-flex-content' [@panelDisplay]="showingOperatorBuilder ? 'hidden' : 'visible'">
        <div class="search-criteria-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
            <div class="field scope-criteria">
                <label soho-label for="item-desc">{{ 'FieldPicker_FieldNameLabel' | translate }}</label>
                <input
                    id="item-desc"
                    data-automation-id="lm-field-picker-field-name"
                    [(ngModel)]="searchOptions.nameValue"
                    (keydown.enter)="onSearchNameEnter($event)"
                    soho-field-filter
                    [fieldDropdownDataSet]="fieldNameComparators"
                    (filtered)="onFieldNameComparatorChange($event)"
                />
            </div>
            <div *ngIf="this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="relatedBusinessClassFilter">{{ 'FieldPicker_BusinessClassScopeLabel' | translate }}</label>
                <select
                        id="relatedBusinessClassFilter"
                        data-automation-id="lm-field-picker-fields-from"
                        soho-dropdown
                        soho-tooltip
                        title="{{ 'FieldPicker_BusinessClassScopeTooltip' | translate }}"
                        style="width: 200px;"
                        [source]="businessClassSource"
                        [(ngModel)]="relatedFieldFilter">
                    <option class="clear"></option>
                    <option *ngFor="let businessClass of businessClasses" [value]="businessClass">{{businessClass}}</option>
                </select>
            </div>
            <div *ngIf="this.options.view !== 'SimpleConditions' && this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="fieldType">{{ 'FieldPicker_FieldTypeLabel' | translate }}</label>
                <select
                        soho-dropdown
                        [ngClass]="'dropdown-md'"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        noSearch
                        id="fieldType"
                        data-automation-id="lm-field-picker-field-type"
                        name="fieldType"
                        style="width: 200px;"
                        [(ngModel)]="includeOptions">
                    <option *ngFor="let option of fieldTypes"
                            [value]="option.value">{{option.label}}</option>
                </select>
            </div>
            <div  *ngIf="this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes'" class="field scope-criteria">
                <label soho-label for="searchScope">{{ 'FieldPicker_SearchDepthLabel' | translate }}</label>
                <select
                        id="searchScope"
                        data-automation-id="lm-field-picker-search-scope"
                        soho-dropdown
                        style="width: 250px;"
                        [(ngModel)]="searchScope">
                    <option [value]="'normal'">{{ 'FieldPicker_SearchDepthNormalLabel' | translate }}</option>
                    <option [value]="'extended'">{{ 'FieldPicker_SearchDepthExtendedLabel' | translate }}</option>
                    <option [value]="'max'">{{ 'FieldPicker_SearchDepthMaxLabel' | translate }}</option>

                </select>
            </div>
        </div>
        <div>
            <div class="lm-search-button-container">
                <button id="fieldPickerSearchBtn" data-automation-id="lm-field-picker-search-button" soho-button="tertiary" class="btn-tertiary lm-run-search-button"
                        (click)="onSearchClicked($event)">{{ 'Search' | translate }}</button>
                <button id="fieldPickerClearBtn" data-automation-id="lm-field-picker-clear-button" soho-button="tertiary" class="btn-tertiary lm-clear-search-button"
                        (click)="onClearSearchClicked($event)">{{ 'Clear' | translate }}</button>
            </div>
            <lm-list-searchtags
                *ngIf="searchingFromHere"
                data-automation-id="lm-field-picker-focus-search-tags"
                automationIdPrefix="field-picker-focus"

                [showRefineAndClear]="false"
                [searchTags]="searchingFromHereTags"
                (searchTagRemoved)="onSearchTagRemoved($event)"
                [iconName]="searchingFromHereContext?.length > 1 ? 'left-arrow' : 'close'"
            ></lm-list-searchtags>
        </div>
        <lm-notification #lmNotificationComponent data-automation-id="lm-field-picker-notification" [notificationType]="'info'" (lmNotificationEvent) = "onNotificationEvent($event)"></lm-notification>
        <div class="row lm-field-picker-datagrid-container">
            <div soho-datagrid #SohoDataGrid
                 *ngIf="gridOptions"
                 data-automation-id="lm-field-picker-data-grid"
                 [gridOptions]="gridOptions"
                 [emptyMessage]="emptyMessage"
                 (expandrow)="onExpandRow($event)"
                 (collapserow)="onCollapseRow($event)"
                 (rowDoubleClicked)="onRowDoubleClicked($event)"
                 (rowClicked)="onRowSelected($event)"
            ></div>
        </div>
    </div>

    <ng-container id="operatorBuilderContainer">
        <div [@panelDisplay]="showingOperatorBuilder ? 'visible' : 'hidden'">
            <h1 *ngIf="options.view === 'Measures'" data-automation-id="lm-field-picker-header" class="fieldset-title lm-header-3">{{ 'FieldPicker_periodOperator_label' | translate }}</h1>
            <h1 *ngIf="options.view !== 'Measures'"  class="fieldset-title lm-header-3">{{ 'FieldPicker_AddOperatorLabel' | translate }}</h1>
            <lm-field-picker-operator #OperatorView *ngIf="showingOperatorBuilder"
                [uiFieldSpec] ="selectedRow"
                [operatorInfo] ="fieldOperatorInfo"
                [auditData] ="options.includeAuditFields"
                [view] ="options.view"
                [validPeriods]="options.validPeriods">
            </lm-field-picker-operator>
        </div>
    </ng-container>
</div>
